import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
 
@Injectable({
  providedIn: 'root'
})
export class LeadService {
 
  // New Backend API URL 
  private leadUrl = 'https://upscmktapi-vulture.upscapital.com/marketingSite/lead-submission';
 
  // Submission lock to prevent double-clicks
  private isSubmitting = false;
 
  private countryNames: { [key: string]: string } = {
    'CA': 'Canada', 'CN': 'China', 'FR': 'France', 'DE': 'Germany',
    'HK': 'Hong Kong', 'IT': 'Italy', 'MX': 'Mexico', 'NL': 'Netherlands',
    'PL': 'Poland', 'ES': 'Spain', 'BE': 'Belgium', 'TH': 'Thailand',
    'GB': 'United Kingdom', 'US': 'United States'
  };
 
  private stateMapping: { [key: string]: string } = {
    "AL": "Alabama", "AK": "Alaska", "AZ": "Arizona", "AR": "Arkansas",
    "CA": "California", "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware",
    "FL": "Florida", "GA": "Georgia", "HI": "Hawaii", "ID": "Idaho",
    "IL": "Illinois", "IN": "Indiana", "IA": "Iowa", "KS": "Kansas",
    "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MD": "Maryland",
    "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi",
    "MO": "Missouri", "MT": "Montana", "NE": "Nebraska", "NV": "Nevada",
    "NH": "New Hampshire", "NJ": "New Jersey", "NM": "New Mexico", "NY": "New York",
    "NC": "North Carolina", "ND": "North Dakota", "OH": "Ohio", "OK": "Oklahoma",
    "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina",
    "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah",
    "VT": "Vermont", "VA": "Virginia", "WA": "Washington", "WV": "West Virginia",
    "WI": "Wisconsin", "WY": "Wyoming"
  };
 
  constructor(private http: HttpClient) {}
 
  /**
   * Submit Lead to the Backend API
   */
  submitLead(formData: any): Observable<any> {
 
    // Block duplicate submission
    if (this.isSubmitting) {
      return EMPTY;
    }
 
    this.isSubmitting = true;
 
    // Map country & state for the final payload
    const mappedCountry = this.countryNames[formData.Country] || formData.Country;
    const mappedState = this.stateMapping[formData.StateProvinceRegion] || formData.StateProvinceRegion;
 
    let howCanWeHelp = formData.HowCanWeHelp == 1
      ? 'I am interested in your services'
      : 'I have a service inquiry';
 
    if (formData.CampaignID == 6) {
      howCanWeHelp = '';
    }
 
    // Constructing the payload
    const leadPayload = {
      leadData: {
        country: mappedCountry,
        state: mappedState,
        firstName: formData.FirstName,
        lastName: formData.LastName,
        email: formData.Email,
        phone: formData.PhoneNumber,
        howcanwehelp: howCanWeHelp,
        areyouaUPSCcustomer: "",
        companyname: formData.CompanyName,
        zipcode: formData.Zipcode,
        comments: "",
        channelvalue: "",
        leadsource: "",
        sourcesystem: "UPSCAPITAL.COM",
        referralurl: formData.Referrer
      }
    };
 
    // Sending the POST request directly to your backend
    return this.http.post<any>(this.leadUrl, leadPayload, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      finalize(() => {
        // Always unlock regardless of success or error
        this.isSubmitting = false;
      }),
      catchError(error => {
        console.error('Lead Submission Error:', error);
        // Rethrow or return EMPTY based on how your component handles errors
        throw error; 
      })
    );
  }
}